import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import '@grandvisionhq/utils';
import { getOpeningHoursSpecification } from '../../utils/get-opening-hours-specification.js';
import { getServices } from '../../utils/get-services.js';
import '@grandvisionhq/lib-utils-react';
import { JsonLd } from '../JsonLd.js';

var OpenClosedStatus;
(function(OpenClosedStatus) {
    OpenClosedStatus["Open"] = 'OPEN';
    OpenClosedStatus["Closing"] = 'CLOSING';
    OpenClosedStatus["Closed"] = 'CLOSED';
})(OpenClosedStatus || (OpenClosedStatus = {}));
const Store = ({ store , url  })=>{
    const features = useFeatureToggles();
    const cleanUrl = url.split('?')[0];
    const { rating  } = store;
    const payload = {
        '@type': 'Store',
        '@id': `${cleanUrl}/${store.town.toLocaleLowerCase()}/${store.slug}#store`,
        url: `${cleanUrl}/${store.town.toLocaleLowerCase()}/${store.slug}`,
        name: store.storeName,
        description: store.metaDescription,
        email: store.storeEmailAddress,
        telephone: store.Phone1,
        image: store.detailImage,
        address: [
            {
                '@type': 'PostalAddress',
                streetAddress: `${store.streetName}`,
                postalCode: store.postalCode,
                addressLocality: store.town,
                addressCountry: store.country
            }, 
        ],
        contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'sales contact point',
            telephone: store.Phone1
        },
        openingHoursSpecification: getOpeningHoursSpecification(store),
        hasOfferCatalog: store.facilities ? getServices(store.facilities) : undefined,
        aggregateRating: features.isStoreRatingsEnabled && rating ? {
            '@type': 'AggregateRating',
            bestRating: 5,
            worstRating: 1,
            ratingValue: rating.value,
            ratingCount: rating.count
        } : undefined
    };
    return /*#__PURE__*/ React.createElement(JsonLd, swcHelpers.extends({}, payload));
};

export { OpenClosedStatus, Store };
//# sourceMappingURL=Store.sd.js.map
